'use client';
import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { ButtonGroup } from '../ButtonGroup/ButtonGroup.js';
import { EmptyState } from '../EmptyState/EmptyState.js';
import { Flex } from '../Flex/Flex.js';

const StyledEmptyState = styled(EmptyState).withConfig({
  componentId: "sc-1ymztns-0"
})(["margin:auto;"]);
const TableEmptyState = /*#__PURE__*/withTitan(_a => {
  var {
      buttons,
      py = 30,
      testId = 'tableEmptyState'
    } = _a,
    props = __rest(_a, ["buttons", "py", "testId"]);
  return jsx(StyledEmptyState, Object.assign({
    isCentered: true,
    py: py,
    testId: testId
  }, props, {
    children: jsx(Flex, {
      justifyContent: "center",
      children: jsx(ButtonGroup, {
        children: buttons
      })
    })
  }));
}, {
  name: 'TableEmptyState'
});

export { TableEmptyState };
//# sourceMappingURL=TableEmptyState.js.map
